/**
 * uc-search-dropdown.js – Dynamic top-bar search dropdown.
 * Uses Shopify predictive search API. Vanilla JS, accessible.
 */
(function () {
  var inited = false;

  function init() {
    if (inited) return;
    inited = true;

    var searchBtn = document.getElementById("uc-search-trigger");
    var dropdown = document.getElementById("uc-search-dropdown");
    var input = document.getElementById("uc-search-input");
    var resultsEl = document.getElementById("uc-search-results");
    var viewAllLink = document.getElementById("uc-search-view-all");

    if (!searchBtn || !dropdown || !input || !resultsEl) return;

    var debounceMs = 150;
    var debounceTimer = null;
    var abortController = null;

    function formatMoney(val) {
      if (val == null || val === "") return "";
      var num = typeof val === "string" ? parseFloat(val) : Number(val);
      if (isNaN(num)) return "";
      var locale =
        (window.Shopify &&
          window.Shopify.locale &&
          window.Shopify.locale.primary_locale) ||
        "en";
      var currency =
        (window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active) ||
        "GBP";
      var formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      var amount =
        num >= 1000 || (num >= 100 && num % 1 === 0) ? num / 100 : num;
      return formatter.format(amount);
    }

    function getSuggestUrl() {
      var root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
      return root + "search/suggest.json";
    }

    function fetchResults(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var params = new URLSearchParams({
        q: query,
        "resources[type]": "product",
        "resources[limit]": "6",
        "resources[options][unavailable_products]": "hide",
      });

      return fetch(getSuggestUrl() + "?" + params.toString(), {
        signal: abortController.signal,
      }).then(function (res) {
        return res.json();
      });
    }

    function renderResults(products, query) {
      if (!products || products.length === 0) {
        resultsEl.innerHTML =
          '<p class="uc-search-results__empty">No results found</p>';
        resultsEl.setAttribute("aria-live", "polite");
        return;
      }

      var html = '<ul class="uc-search-results__list" role="list">';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || "";
        var imgTag = img
          ? '<img src="' +
            img.replace(/&/g, "&amp;") +
            '" alt="" width="48" height="48" loading="lazy" class="uc-search-result__img">'
          : '<span class="uc-search-result__img uc-search-result__img--placeholder"></span>';
        var price = p.price != null ? formatMoney(p.price) : "";
        var priceEl = price
          ? '<span class="uc-search-result__price">' + price + "</span>"
          : "";

        html += '<li class="uc-search-result">';
        html +=
          '<a href="' +
          (p.url || "#").replace(/"/g, "&quot;") +
          '" class="uc-search-result__link">';
        html += '<span class="uc-search-result__thumb">' + imgTag + "</span>";
        html += '<span class="uc-search-result__info">';
        html +=
          '<span class="uc-search-result__title">' +
          (p.title || "").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
          "</span>";
        if (priceEl) html += priceEl;
        html += "</span>";
        html += "</a>";
        html += "</li>";
      });
      html += "</ul>";

      resultsEl.innerHTML = html;
      resultsEl.setAttribute("aria-live", "polite");
    }

    function setState(state) {
      resultsEl.setAttribute("data-state", state);
      if (state === "loading") {
        resultsEl.innerHTML =
          '<p class="uc-search-results__loading">Searching…</p>';
      } else if (state === "empty") {
        resultsEl.innerHTML = "";
      }
    }

    function doSearch() {
      var query = (input.value || "").trim();
      if (!query) {
        setState("empty");
        return;
      }

      setState("loading");
      fetchResults(query)
        .then(function (data) {
          var products =
            (data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];
          renderResults(products, query);
          if (viewAllLink) {
            viewAllLink.href = buildSearchUrl(query);
            viewAllLink.style.display = "block";
          }
        })
        .catch(function (err) {
          if (err.name === "AbortError") return;
          renderResults([]);
        });
    }

    function debouncedSearch() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, debounceMs);
    }

    function openDropdown() {
      dropdown.classList.add("is-open");
      dropdown.setAttribute("aria-hidden", "false");
      searchBtn.setAttribute("aria-expanded", "true");
      input.focus();
      input.value = "";
      setState("empty");
      if (viewAllLink) viewAllLink.style.display = "none";
      document.addEventListener("click", onDocClick);
      document.addEventListener("keydown", onKeydown);
    }

    function closeDropdown() {
      dropdown.classList.remove("is-open");
      dropdown.setAttribute("aria-hidden", "true");
      searchBtn.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKeydown);
      if (searchBtn) searchBtn.focus();
    }

    function onDocClick(e) {
      if (!dropdown.contains(e.target) && !searchBtn.contains(e.target)) {
        closeDropdown();
      }
    }

    function getSearchBaseUrl() {
      var el = document.getElementById("uc-search-dropdown");
      return (el && el.getAttribute("data-search-url")) || "/search";
    }

    function buildSearchUrl(query) {
      var base = getSearchBaseUrl().split("?")[0];
      return (
        base +
        (base.indexOf("?") >= 0 ? "&" : "?") +
        "q=" +
        encodeURIComponent(query)
      );
    }

    function onKeydown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeDropdown();
      } else if (e.key === "Enter" && e.target === input) {
        e.preventDefault();
        var q = (input.value || "").trim();
        if (q) window.location.href = buildSearchUrl(q);
      }
    }

    function trapFocus(e) {
      if (e.key !== "Tab") return;
      var focusable = dropdown.querySelectorAll(
        'a[href], button, input, [tabindex]:not([tabindex="-1"])',
      );
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    searchBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (dropdown.classList.contains("is-open")) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    input.addEventListener("input", debouncedSearch);
    input.addEventListener("keydown", trapFocus);
    dropdown.addEventListener("keydown", trapFocus);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
